var productMetaJson = JSON.parse(document.getElementById('product-meta-json').textContent);
$(document).on('click', '#dropdown_info', function() {
  window.location.hash = '#popup';
  $(".Weitere-model-main").addClass('model-open');
  $("body").addClass('popup_active');
}); 
$(document).on('click', ".Weitere_close_btn, .Weitere_bg_overlay", function(){
  if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".Weitere-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
});

$(document).on('click', '#halskette_short_textnain', function() {
  window.location.hash = '#popup';
  $(".Handzeichnung-model-main").addClass('model-open');
  $("body").addClass('popup_active');
}); 
$(document).on('click', ".Handzeichnung_close_btn, .Handzeichnung_bg_overlay", function(){
  if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".Handzeichnung-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
});

 // front side btn open popup 
$(document).on('click', '#name_popupbox', function() {
  var id = $('[data-product-select]').val();
    var selectedlength = $('.select-trigger .selected-option .list_item').length;
    var selectedValueNbr = $('.select-trigger .selected-option .list_item').find('.list_item_value').attr('data-number');
  if(!selectedValueNbr){
    var selectedValueNbr = 1;
  }
console.log(selectedValueNbr);
    Object.keys(productMetaJson).forEach(function(key) {
    if(productMetaJson[key].variant_id == id){
    var productProperties = productMetaJson[key].img[0];
    $('.Namen-model-main .wrap_image_container img').attr("src",productProperties);
      $('.Namen-model-main .wrap_image_container').attr('data-person', selectedValueNbr);
    }
    });

    setTimeout(function() {
      window.location.hash = '#popup';
     $(".Namen-model-main").addClass('model-open');
      $("body").addClass('popup_active');
    }, 500);
}); 

$(document).on('change', '[data-variant-input]', function(){
  getPrice();
  var id = $('[data-product-select]').val();
    // console.log("chan");
 Object.keys(productMetaJson).forEach(function(key) {
    if(productMetaJson[key].variant_id == id){
    var productProperties = productMetaJson[key].img[0];
        // console.log(productProperties);
    $('.Namen-model-main .wrap_image_container img').attr("src",productProperties);
    }
    });
});


// front side cancel/skip btn open popup

$(document).on('click', '.halskette_frontname_texts .fflagship-collapsable-header-button2', function(){
 var id = $('[data-product-select]').val();
  var selectedlength = $('.select-trigger .selected-option .list_item').length;
  var selectedValueNbr = $('.select-trigger .selected-option .list_item').find('.list_item_value').attr('data-number');
  if(!selectedValueNbr){
    var selectedValueNbr = 1;
  }
    Object.keys(productMetaJson).forEach(function(key) {
    if(productMetaJson[key].variant_id === id){
    console.log(selectedValueNbr);
    var productProperties = productMetaJson[key].img[selectedValueNbr-1];
    console.log(productProperties);
    $('.Namen-model-main .wrap_image_container img').attr("src",productProperties);
    }
    });
    setTimeout(function() {
      window.location.hash = '#popup';
     $(".Namen-model-main").addClass('model-open');
     $("body").addClass('popup_active'); 
    }, 500);
});


$(document).on('click', ".Namen_close_btn, .Namen_bg_overlay", function(){
  if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".Namen-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
});


$(document).on('click', '#upload_info', function() {
  window.location.hash = '#popup';
  $(".aufFoto-model-main").addClass('model-open');
  $("body").addClass('popup_active');
}); 
$(document).on('click', ".aufFoto_close_btn, .aufFoto_bg_overlay", function(){
  if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".aufFoto-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
});

$(document).on('click', ".select-trigger", function(){
    $(".options").slideToggle("fast");
    $(this).toggleClass('selector_open');
  $(this).parents('.custom-select').find('#halskette_select').toggleClass('selected_open');
  });

$(document).on('click', "#halskette_select.options li", function(){
    var selectedOption = $(this).html();
    var selectedValue = $(this).attr("value");
  $('.Namen-model-main .frontname').removeClass('name_active');
var selectedDataVal = $(this).parents('.halskette_selecteditems').find('.select-trigger .selected-option .list_item .list_item_value').attr('data-value');
$('.halskette_frontname_texts .halskette_name_texts').html('');
  $('.halskette_frontname_texts .frontnamecancel_btn').show();
  $('.halskette_frontname_texts .halskette_name_btn').show();
  $('.Namen-model-main #popup_name_image').html('');
  $('.Namen-model-main .popup_name_inputs').val('');
  
  $('.Namen-model-main #frontname_1').addClass('name_active');
  $('.halskette_frontname_texts .halskette_header').show();
$('.halskette_frontname_texts .halskette_input_first').show();
  $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('');
  $(".selected-option").html(selectedOption);
  $('.halskette_personen').val($(this).find('.list_item_value').attr('data-valuePrice'));
  $("#halskette_select.options").slideUp("fast");
  $("#halskette_select.options").removeClass("selected_open");
  $(this).parents('.custom-select').find('.select-trigger').removeClass('selector_open');
  // Perform any additional actions with the selected value here
  $('.add-to-cart').removeClass('disabled');
  $('.error').hide();
  $('.select-trigger').removeClass('error-text');
  getPrice();
  });

  
$(document).on('click', '.Namen-model-main .popup_fonts .frontname', function(){
$('.Namen-model-main .popup_fonts .frontname').removeClass('name_active');
$(this).addClass('name_active');

var fontName= $(this).attr('data-named');
//$('.popup_name_inputs'+fontName+'').show();

var fontimageName= $(this).attr('data-imagename');
$('#popup_name_image').attr('data-font',fontName);
$('#popup_name_image').attr('class', fontimageName); 

var inputValue = $('.Namen-model-main .frontnameinput_1').val();
var convertedValue = inputValue;
var elements = $('.frontname_4.name_active');
if (elements.length > 0) {
var words = inputValue.split(' ');
 for (var i = 0; i < words.length; i++) {
  var word = words[i];
  var wordFirstCharacter = word.charAt(0);
  var wordRestOfText = word.substr(1).toLowerCase();
  words[i] = wordFirstCharacter + wordRestOfText;
 }
 var convertedValue = words.join(' ');
$('.Namen-model-main .frontnameinput_1').val(convertedValue);
}
$('.Namen-model-main #popup_name_image').html(convertedValue);

  updateFontSizes($(this).parents('.Namen-model-main').find('.frontnameinput_1'));

});


// name front side popup save btn
$(document).on('click', '.Namen-model-main .image_save_btn', function(){
$('.halskette_frontname_texts .halskette_name_texts').html('');
  $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('');
var fontName = $(this).parents('.Namen-model-main').find('.frontname.name_active').attr('data-fontname');
 var nameInputVal = $(this).parents('.Namen-model-main').find('.popup_name_inputs').val();
var index = $(this).parents('.Namen-model-main').find('.frontname.name_active').attr('data-numberdata');
  var indexPlus = index * 1;
  if(nameInputVal != ''){
    console.log(indexPlus);
    console.log(nameInputVal);
     $('.halskette_frontname_texts .halskette_name_texts').show();
    $('.halskette_frontname_texts .halskette_input_first').show();
    $('.halskette_frontname_texts .halskette_header').hide();
    
    
     $('.halskette_frontname_texts .halskette_name_texts').append('<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="halskette_header halskette_headernew" style="display:block;"><div class="halskette_heading">Name</div></div><div class="engraving-messagesection row" data-autom="engraving-message-'+indexPlus+'"><div class="engraving-messagesection-item"><span style="display:none;">Name: </span><input class="popup_name_inputproperties inputsproperty_'+indexPlus+'" type="hidden" value="'+nameInputVal+'" name="properties[Name]"><input class="popup_font_inputproperties fontproperty_'+indexPlus+'" type="hidden" value="'+fontName+'" name="properties[_Schriftart]"><span class="engraving-mixed engraving-messagevalue">'+nameInputVal+'</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-trigger-id=".frontname_'+indexPlus+'"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_'+indexPlus+'" data-img-id=".frontnameimg_'+indexPlus+'" data-trigger-id=".frontname_'+indexPlus+'"><span>löschen</span></button></div></div>');
    $('.halskette_frontname_texts .halskette_name_btn').hide();
if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
    $(".Namen-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
    $('.halskette_frontname_texts .frontnamecancel_btn').hide();
  }else{
    $('.halskette_frontname_texts .halskette_input_first').hide();
     $('.halskette_frontname_texts .halskette_header').hide();
    $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Name überspringen</span><button class="flagship-collapsable-header-button" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');
if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".Namen-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
    $('.halskette_frontname_texts .frontnamecancel_btn').hide();
  }

});


// name front side cancel btn
$(document).on('click', '.Namen-model-main .image_cancel_btn', function(){
  $('.Namen-model-main .popup_name_inputs').each(function(){
   // console.log($('.halskette_frontname_texts .halskette_name_texts').children().length);
    if($('.halskette_frontname_texts .halskette_name_texts').children().length > 0){
      $('.halskette_frontname_texts .halskette_name_btn').hide();
    }else{
      $(this).val('');
      console.log($('.halskette_frontname_texts .halskette_name_cancel_databtn').children().length);
      if($('.halskette_frontname_texts .halskette_name_cancel_databtn').children().length > 0){
        $('.halskette_frontname_texts .halskette_name_texts').hide();
      $('.halskette_frontname_texts .halskette_name_btn').hide();
      }else{
        $('.halskette_frontname_texts .halskette_name_texts').hide();
      $('.halskette_frontname_texts .halskette_name_btn').show();
      }
    }
if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
 $(".Namen-model-main").removeClass('model-open');
    $("body").removeClass('popup_active');
  });
});




// front side cancel/skip btn
$(document).on('click', '.frontnamecancel_btn .halskette_name_btn', function(){
  $('.halskette_frontname_texts .halskette_header').hide();
  $('.halskette_frontname_texts .halskette_input_first').hide();
  $(this).hide();
  $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Name überspringen</span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');

});

// back side cancel/skip btn
$(document).on('click', '.backnamecancel_btn .halskette_name_btn', function(){
  $('.halskette_backname_texts .halskette_header').hide();
  $('.halskette_backname_texts .halskette_input_first').hide();
  $(this).hide();
  $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');
});

// name front side edit btn
$(document).on('click', '.halskette_frontname_texts .engraving-editbutton', function(){
  var datatriggerId = $(this).attr('data-trigger-id');
  window.location.hash = '#popup';
$(".Namen-model-main").addClass('model-open');
$("body").addClass('popup_active');
  $(".Namen-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
$(".Namen-model-main .popup_fonts").find(datatriggerId).trigger('click');
});



// name front side remove btn
$(document).on('click', '.halskette_frontname_texts .engraving-remove', function(){
$('.halskette_name_texts').hide();
$('.halskette_frontname_texts .halskette_name_btn').show();
  $('.halskette_frontname_texts .halskette_input.frontnamecancel_btn').show();
  $('.halskette_frontname_texts .halskette_header').show();
    
  $(this).parents('.halskette_frontname_texts ').find('.halskette_name_texts').html('');
  $('.Namen-model-main').find('#popup_name_image').html('');
  $('.Namen-model-main').find('.popup_name_inputs').val('');

});


$(document).on('click', '.halskette_frontname_texts .engraving-addedbutton', function(){
  var datatriggerId = $(this).attr('data-trigger-id');
  window.location.hash = '#popup';
$(".Namen-model-main").addClass('model-open');
$("body").addClass('popup_active');
  $(".Namen-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
$(".Namen-model-main .popup_fonts").find(datatriggerId).trigger('click');
});

$(document).on('click', '.halskette_frontname_texts .flagship-collapsable-header-button', function(){
  window.location.hash = '#popup';
$(".Namen-model-main").addClass('model-open');
$("body").addClass('popup_active');
  $(".Namen-model-main .popup_fonts").find('.frontname_1').addClass('name_active');
$(".Namen-model-main .popup_fonts").find('.frontname_1').trigger('click');
});

$(document).on('click', '.halskette-product-add-btn.add-to-cart.disabled', function(event){
event.preventDefault();
$('.error').show();
$('.select-trigger').addClass('error-text');
});

$(document).on('change', '.halskette_radio input', function(){
changeAddHalsketteProduct();
  getPrice();
});

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function changeAddHalsketteProduct(){
var list_item_value = $('.selected-option span.list_item_value').text();
var checkedValue = $('.halskette_radio input:checked').attr('id');

var mainProductvarId = $('.addHalsketteProduct').parents('.product-single__form').find('.product-single__variants').val();
  console.log(mainProductvarId);
if( !(list_item_value == '1 Tier/Person' || list_item_value == '' ) || checkedValue == 'Ja'){
var title = list_item_value + ' / ' + checkedValue;
var id = $('.addHalsketteProduct option[data-title="'+title+'"]').attr('value');
$('.addHalsketteProduct').val(id);
}
}

function addHalsketteProduct(){
var list_item_value = $('.selected-option span.list_item_value').attr('data-number');
//var mainProductvarId = $('.addHalsketteProduct').parents('.product-single__form').find('.product-single__variants').val();
var mainProductvarId = getRandomInt(10000, 99999);
var items = [];
var bundleItem = [];

if(list_item_value != '1'){
var id = $('.addHalsketteProduct option[data-title="'+list_item_value+'"]').attr('value');
items.push({ 'id':id,'quantity':1, 'properties': {'_bundleWithItem': mainProductvarId} });
bundleItem.push(id);
}
var checkedValue = $('.halskette_radio input:checked').attr('id');

if(checkedValue == 'Ja'){
var id = $('.handzeichnung').val();
items.push({ 'id':id,'quantity':1, 'properties': {'_bundleWithItem': mainProductvarId} });
bundleItem.push(id);
}

$('.bundleItem').val(mainProductvarId);
  var data = {
    items: items
  };
 $.ajax({
   type: 'POST', 
   url: '/cart/add.js',
   dataType: 'json', 
   data : data,
   success: function() {
    console.log('added');
   }
});
}



function getPrice(){
var id = $('[data-product-select]').val();
var price = $(`[data-product-select] option[value="${id}"]`).attr('data-price') * 1;
console.log(price);
var personen = $('.halskette_personen').val();
if(!(personen == '1' || personen == '' || personen == undefined )){
var halskette_personen_price = $('.addHalsketteProduct option[data-title="'+personen+'"]').attr('data-price') * 1;
price = price + halskette_personen_price * 1;
console.log(price);
}
var checkedValue = $('.halskette_radio input:checked').attr('id');

if(checkedValue == 'Ja'){
var handzeichnung_price = $('.handzeichnung').attr('data-price') * 1;
price = price + handzeichnung_price; 
  console.log(price);
}

var formattedAmount =  theme.Currency.formatMoney(price,theme.settings.moneyFormat);
$('[data-product-price]').text(formattedAmount);
}



function uploadkit(){
  if($('.uploadkit-thumbnail').children().length == 0){
     $('.custom_uploadkit .uploadkit-uploader .image_save').remove(); 
   }
 $('.uploadkit-thumbnail').each(function(index) {
    var image = $(this);
    var field = image.next('.uploadkit-field');
    var wrapper = image.closest('.uploadkit-main-wrapper');
   //console.log($(this).find('.uploadkit-main-wrapper').length);
    if (wrapper.length === 0) {
      wrapper = $('<div class="uploadkit-main-wrapper"></div>');
      image.add(field).wrapAll(wrapper);
            $(this).wrap($('<div class="uploadkit-wrapper-img"></div>'));
      $(this).wrap($('<div class="wrapper-img"></div>'));

    }
   //console.log($('.uploadkit-thumbnail').children().length);
   
  // console.log($('.uploadkit-main-wrapper').length);
   if($('.uploadkit-main-wrapper').length == 2 || $('.uploadkit-main-wrapper').length == 1){
     $('.uploadkit-main-wrapper').css('width', '45%');
   }
   if($('.uploadkit-main-wrapper').length == 3 || $('.uploadkit-main-wrapper').length == 4 || $('.uploadkit-main-wrapper').length == 5){
   $('.uploadkit-main-wrapper').css('width', '31%');
   }
   if($('.custom_uploadkit .uploadkit-uploader .image_save').length == 0){
     if($('.uploadkit-main-wrapper').length >= 1){
       $('.custom_uploadkit').find('.uploadkit-button.uploadkit-button-uploaded').before('<button type="button" class="image_save">Sichern</button>');
       $('.custom_uploadkit .uploadkit-uploader').find('.uploadkit-button.uploadkit-button-uploaded').addClass('uploaded_button_full');
   }
   }
  });
} 
setInterval(uploadkit, 800);


$(document).on('click', '.uploadkit-wrapper-img', function(event){
 if ($(event.target).is('div.wrapper-img')) {
  $(this).find('img.uploadkit-thumbnail').trigger('click');
 }
});
$(document).on('click', '.image_save', function(event){
  $('.halsketteupload_header').hide();
  $('.halsketteupload_content').hide();
  $('.after_upload_photo').show();

  // setTimeout(function(){
    $('html, body').animate({
        scrollTop: $("#foto").offset().top - 150
    }, 400); 
  // },500);
 
});

$(document).on('click', '.halsketteupload_edit_text', function(event){
  $('.after_upload_photo').hide();
  $('.halsketteupload_header').show();
  $('.halsketteupload_content').show();
});

$('.Namen-model-main .frontnameinput_1').on('keyup', function(){
var inputValue = $(this).val();
var convertedValue = inputValue;

$('.Namen-model-main #popup_name_image').html(convertedValue);
  updateFontSizes($(this));
});


function updateFontSizes(item) {
  var text = item.val();
  var characters = text.length;
  var num = item.attr('data-number');
  console.log(num);
  console.log(characters);
  var popupName1 = $('.Namen-model-main .frontnameimg_1');
    if (characters <= 2) {
      popupName1.css('font-size', '14px');

    }else if (characters <= 3) {
      popupName1.css('font-size', '14px');

      
    } else if (characters <= 4) {
      popupName1.css('font-size', '14px');
      
    } else if (characters <= 5) {
      popupName1.css('font-size', '14px');
      
    } else if (characters <= 6) {
      popupName1.css('font-size', '14px');
    
    } else if (characters == 7) {
      popupName1.css('font-size', '14px');
     
    } else if (characters == 8) {
      popupName1.css('font-size', '14px');
  
    } else if (characters == 9) {
      popupName1.css('font-size', '14px');

    } else if (characters == 10) {
      popupName1.css('font-size', '14px');
    
    }else if (characters == 11) {
      popupName1.css('font-size', '14px');

    }else if (characters == 12) {
      popupName1.css('font-size', '14px');
   
    }else if (characters == 13) {
      popupName1.css('font-size', '14px');
    
    }else if (characters <= 14) {
      popupName1.css('font-size', '14px');

    }else if (characters == 15) {
      popupName1.css('font-size', '14px');

    }else if (characters == 16) {
      popupName1.css('font-size', '14px');

    }else if (characters == 17) {
      popupName1.css('font-size', '14px');

    }else if (characters == 18) {
      popupName1.css('font-size', '13px');

    }else if (characters == 19) {
      popupName1.css('font-size', '13px');

    }else if (characters == 20) {
      popupName1.css('font-size', '12px');

    }else if (characters == 21) {
      popupName1.css('font-size', '12px');

    }else if (characters == 22) {
      popupName1.css('font-size', '12px');

    }else if (characters == 23) {
      popupName1.css('font-size', '12px');

    }else if (characters == 24) {
      popupName1.css('font-size', '10px');

    }
  else if (characters >= 25) {
      popupName1.css('font-size', '10px');

    }
}


var interval = setInterval(checkURL, 1000);
function checkURL() {
    var currentURL = window.location.href;
    if (currentURL.indexOf('#') === -1) {
    $('.aufFoto-model-main').removeClass('model-open');
    $(".Weitere-model-main").removeClass('model-open');
    $(".Zeichnungsstil-model-main").removeClass('model-open');
    $(".Handzeichnung-model-main").removeClass('model-open');
    $(".Namen-model-main").removeClass('model-open');
    $(".Ruckseitengravur-model-main").removeClass('model-open');
    $('body.template-product').removeClass('popup_active');
}
}
